export const PRIMARY_CONTACT_OPTIONS = {
  NOTES: "Patient.PrimaryContact.Notes",
  EMAIL_ADDRESS: "Patient.PrimaryContact.EmailAddress",
  PREFERRED_COMMUNICATION_METHOD:
    "Patient.PrimaryContact.PreferredCommunicationMethod",
  PHONE: "Patient.PrimaryContact.Phone",
  TYPE_OF_PHONE_NUMBER: "Patient.PrimaryContact.TypeOfPhoneNumber",
  FULL_ADDRESS: "Patient.PrimaryContact.FullAddress",
  STREET_ADDRESS_LINE1: "Patient.PrimaryContact.StreetAddressLine1",
  STREET_ADDRESS_LINE2: "Patient.PrimaryContact.StreetAddressLine2",
  CITY: "Patient.PrimaryContact.City",
  STATE: "Patient.PrimaryContact.State",
  ZIP_CODE: "Patient.PrimaryContact.ZIPCode",
};
